
        <img
          class="modal__poster"
          src="{{poster_path}}"
          alt="{{title}}"
          width="240"
          height="357"
        />
      <div class="modal__info">
        <h3 class="modal__title">{{title}}</h3>
        <table class="modal__table">
          <tbody>
            <tr>
              <th class="modal__subtitle--table">Vote / Votes</th>
              <th class="modal__table--text">
                <span class="modal__table--vote modal__rating">{{vote_average}}</span>
                <span class="table--splash">/</span>
                <span class="modal__rating">{{vote_count}}</span>
              </th>
            </tr>
            <tr>
              <th class="modal__subtitle--table">Popularity</th>
              <th class="modal__table--text">{{popularity}}</th>
            </tr>
            <tr>
              <th class="modal__subtitle--table">Original Title</th>
              <th class="modal__table--text">{{title}}</th>
            </tr>
            <tr>
              <th class="modal__subtitle--table">Genre</th>
              <th class="modal__table--text">{{genre_ids}}</th>
            </tr>
          </tbody>
        </table>
        <h4 class="modal__subtitle">about</h4>
        <p class="modal__desc">{{overview}}
        </p>
    <div class="modal__btns">
          <button type="button" class="btn--add active button" data-remove>remove</button>
          <button type="button" class="btn--add button" data-move>add to queue</button>
          <button type="button" class="btn--add btn--trailer" data-trailer>try to find trailer</button>

        </div>
      </div>
    </div>
  </div>
</div>